<template>
  <el-form ref="emailForm" :model="formData" :rules="rules" label-position="left" label-width="auto" style="width: 600px" >
    <el-form-item prop="email" :label="$t('lang.您的邮箱地址')">
      <el-input v-model="formData.email"></el-input>
    </el-form-item>

    <el-form-item size="medium" style="display: flex;justify-content: center">
      <el-button size="medium" type="primary" style="width: 120px" @click="handleNext">{{$t('lang.下一步')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "VerifyEmailForm",
  data() {
    return {
      formData: {
        email: ""
      }
    }
  },
  computed: {
    rules() {
      return {
        email: [
          { required: true, message: this.$t('lang.请输入邮箱地址'), trigger: 'blur' },
          { type: 'email', message: this.$t('lang.请输入正确的邮箱地址'), trigger: ['blur'] }
        ],
      }
    }
  },
  methods: {
    handleNext() {
      const vm = this;
      this.$refs['emailForm'].validate((valid) => {
        if (valid) {
          vm.$emit('next', vm.formData);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
